import React, { useEffect, useState } from 'react'

import { Track, useTrack } from '../../../webrtc/webRTCRoom'
import { useSelectedAudioOutputDevice } from '../../../Devices/useDevices'
import { getRole } from '../../../global/roomInfo/roomInfo'
import { logMessage } from '../../../Logging/sentry'

interface AudioTrackProps {
  track: Track
}

const AudioTrack = ({ track }: AudioTrackProps) => {
  const audioOutputDeviceId = useSelectedAudioOutputDevice()
  const role = getRole()
  const [trackElementRef, setTrackElementRef] =
    useState<HTMLAudioElement | null>(null)
  useTrack(track, trackElementRef)

  const isMuted =
    ((role === 'presenter' || role === 'producer') && !audioOutputDeviceId) ||
    !track.isEnabled

  useEffect(() => {
    if (audioOutputDeviceId) {
      trackElementRef?.setSinkId?.(audioOutputDeviceId).catch((error) => {
        logMessage('Failed to set audio output device', {
          level: 'warning',
          extra: { deviceId: audioOutputDeviceId, cause: error },
        })
      })
    }
  }, [audioOutputDeviceId, trackElementRef])

  // eslint-disable-next-line jsx-a11y/media-has-caption
  return <audio muted={isMuted} ref={setTrackElementRef} />
}

export { AudioTrack }
